import { YinzCamSoccerAppServer } from './YinzCamSoccerAppServer';
import { YinzCamAPI } from 'yinzcam-api';
import { register } from 'yinzcam-registry';
import { APP_SERVER_REGISTRY } from './constants';

@register(APP_SERVER_REGISTRY, 'fa')
export class YinzCamFAAppServer extends YinzCamSoccerAppServer {
  public constructor(api: YinzCamAPI) {
    super(api);
  }
}
